import styled from 'styled-components';

export const ListInfo = styled.ul`
  padding-right: 1em;
  padding-left: 3em;
  li {
    color: #f57e44;
  }
`;
